import type { FormValidationErrors } from "~/shared/hooks/use-form-validation.ts";

/**
 * Only keys that block a tender are listed here; length/format-only keys
 * (e.g. `pickupNameLength`) are deliberately excluded from the banner.
 */
const FIELD_LABELS: Record<string, string> = {
	pickupName: "Pickup Location Name",
	pickupShipmentDate: "Pickup Date",
	pickupAddress1: "Pickup Address",
	pickupHoursFrom: "Pickup Hours Open",
	pickupHoursTo: "Pickup Hours Close",
	deliveryName: "Delivery Location Name",
	deliveryAddress1: "Delivery Address",
	deliveryContactPhone: "Delivery Contact Phone",
	deliveryHoursFrom: "Delivery Hours Open",
	deliveryHoursTo: "Delivery Hours Close",
	emergencyContactName: "Emergency Contact Name",
	emergencyContactPhone: "Emergency Contact Phone",
};

const ITEM_FIELD_LABELS: Record<string, string> = {
	description: "Description",
	pieceCount: "Piece Count",
	nmfc: "NMFC",
	unNumber: "UN Number",
	properShippingName: "Proper Shipping Name",
	hazmatClass: "Hazmat Class",
	packingGroupId: "Packing Group",
};

const orderedLabels = (
	keys: Set<string>,
	labels: Record<string, string>,
): string[] =>
	Object.entries(labels)
		.filter(([key]) => keys.has(key))
		.map(([, label]) => label);

/**
 * Human-readable list of the details a bulk-tendered shipment is still
 * missing, ordered to match the order the fields appear on the page.
 */
export const getMissingDetailLabels = (
	errors: FormValidationErrors,
	itemIds: readonly number[],
): string[] => {
	const missing = orderedLabels(errors.fields, FIELD_LABELS);

	for (const [index, itemId] of itemIds.entries()) {
		const itemErrors = errors.items[itemId];
		if (!itemErrors) continue;
		for (const label of orderedLabels(itemErrors, ITEM_FIELD_LABELS)) {
			missing.push(`Handling Unit ${index + 1}: ${label}`);
		}
	}

	return missing;
};
